module.exports = __webpack_public_path__ + "media/images/icon-radio-outline-560dc972cf8bbc689e99bff4e91cedef.svg";